export const MEDITATION_MELODIES = [
  { 
    id: 'BELL_MEDITATION', 
    name: 'Bell Meditation',
    audioFile: '/sounds2/bell-meditation.mp3',
    frequency: 528,
    type: 'sine',
    description: '冥想铃声 - 专为冥想设计的宁静铃声'
  },
  { 
    id: 'CHIME_MEDITATION', 
    name: 'Chime Meditation',
    audioFile: '/sounds2/chime.mp3',
    frequency: 720,
    type: 'sine',
    description: '冥想钟声 - 悦耳的钟鸣声，适合冥想开始和结束'
  },
  { 
    id: 'GENTLE_MEDITATION', 
    name: 'Gentle Meditation',
    audioFile: '/sounds2/gentle.mp3',
    frequency: 440,
    type: 'sine',
    description: '轻柔冥想 - 温和的提示音，适合间隔提醒'
  },
  { 
    id: 'NATURE_MEDITATION', 
    name: 'Nature Meditation',
    audioFile: '/sounds2/nature.mp3',
    frequency: 550,
    type: 'triangle',
    description: '自然冥想 - 鸟鸣声，营造自然冥想氛围'
  }
];